import React, { forwardRef, useContext, useMemo } from 'react';
import clsx from 'clsx';
import { BackIcon } from '../icons';
import { Typography } from '../typography';
import { RegularButton } from '../button';
import styles from './styles.module.css';
import { ScrollContext } from './context';
/**
 * `<DrawerHeader>` - Обёртка для контента хэдера Drawer.
 * Предоставляет стили и логику для хедера.
 */
export const DrawerHeader = /*#__PURE__*/forwardRef(function DrawerHeader({
  title,
  onClickBack,
  className,
  children,
  sticky,
  ...props
}, ref) {
  const testId = props['data-testid'] || 'drawer-header';
  const {
    top
  } = useContext(ScrollContext);
  const classNameHeader = useMemo(() => clsx(styles.header, {
    [styles.withAdornment]: React.Children.count(children) > 0,
    [styles.sticky]: !!sticky,
    [styles.shadow]: !!top
  }, className), [className, sticky, children, top]);
  return /*#__PURE__*/React.createElement("header", {
    ...props,
    className: classNameHeader,
    ref: ref,
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(RegularButton, {
    label: "\u043D\u0430\u0437\u0430\u0434",
    variant: "pseudo",
    size: "s",
    className: styles.back,
    onClick: onClickBack,
    "data-testid": `${testId}-back`,
    iconOnly: true
  }, /*#__PURE__*/React.createElement(BackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: styles.title,
    "data-testid": `${testId}-title`
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.adornment,
    "data-testid": `${testId}-adornment`
  }, children));
});